import React, { useState } from 'react';
import carImage from "../assets/car23.png";

const Download = () => {
  const [showModal, setShowModal] = useState(false);

  return (
    <div className="page">
      <section className="download-content">
        <div className="download-section">

          {/* LEFT CONTENT */}
          <div className="download-info">
            <h1>Get the <span style={{ color: "#184080"}}>Drivve&trade;</span> App</h1>
            <p style={{ fontSize: "20px"}}>
              Join Drivve&trade; to save time, reduce costs,
              and travel more sustainably every day.
            </p>

            {/* FEATURES */}
            <div className="download-features">
              {[
                " Find rides in seconds",
                "Real-time ride tracking",
                "Driver & rider ratings",
                "24/7 customer support",
              ].map((text, i) => (
                <div className="feature" key={i}>
                  <i className="bi bi-check-circle-fill" />
                  <span>{text}</span>
                </div>
              ))}
            </div>

            {/* DOWNLOAD BUTTONS */}
            <div className="download-buttons">
              <button
                className="store-button apple"
                onClick={() => setShowModal(true)}
              >
                <i className="bi bi-apple" />
                <div>
                  <small>Download on the </small>
                  <strong>App Store</strong>
                </div>
              </button>

              <button
                className="store-button google"
                onClick={() => setShowModal(true)}
              >
                <i className="bi bi-google-play" />
                <div>
                  <small>Get it on </small>
                  <strong>Google Play</strong>
                </div>
              </button>
            </div>

            {/* QR */}
         
          </div>

          {/* RIGHT IMAGE */}
          <div className="about-image">
            <img
              src={carImage}
              alt="Drivve carpooling"
              className="about-car-image"
            />
          </div>
        </div>

        {/* TESTIMONIALS */}
        {/* <div className="testimonials">
          <h2>Loved by Our Users</h2>
          <div className="testimonial-cards">
            <div className="testimonial-card">
              “Drivve&trade; reduced my commute cost by more than half.”
              <span>— Alex, Daily Commuter</span>
            </div>
            <div className="testimonial-card">
              “As a driver, I offset my fuel costs every month.”
              <span>— Maya, Driver</span>
            </div>
            <div className="testimonial-card">
              “Clean UI, safe rides, and reliable people.”
              <span>— Robert, Rider</span>
            </div>
          </div>
        </div> */}

        {/* FAQ CARD (RUNNING) */}
      <div className="faq-section">
  <h2 style={{ color: "#184080"}}>Frequently Asked Questions</h2>

  <div className="faq-cards">
    <div className="faq-item">
      <h3>Is Drivve&trade; free?</h3>
      <p style={{ fontSize: "16px"}}>Yes, downloading the app is completely free.</p>
    </div>

    <div className="faq-item">
      <h3>Can I earn money?</h3>
      <p style={{ fontSize: "16px"}}>Yes, drivers earn money by sharing rides.</p>
    </div>

    <div className="faq-item">
      <h3>Is Drivve&trade; safe?</h3>
      <p style={{ fontSize: "16px"}}>All users are verified and rides are monitored.</p>
    </div>

    <div className="faq-item">
      <h3>Does Drivve&trade; work in my city?</h3>
      <p style={{ fontSize: "16px"}}>We are expanding rapidly to new cities.</p>
    </div>
  </div>
</div>

      </section>

      {/* COMING SOON MODAL */}
      {showModal && (
        <div className="modal-overlay" onClick={() => setShowModal(false)}>
          <div className="modal" onClick={(e) => e.stopPropagation()}>
            <h1>Coming Soon</h1>
            <p style={{ color: "#130F0F" }}>
              The Drivve&trade; app is launching soon. <br/>We’re finalizing features and
              preparing for release.
            </p>
            <button
              className="btn btn-primary"
              onClick={() => setShowModal(false)}
            >
              Got it
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default Download;
